import { render, staticRenderFns } from "./AddSingleUserFromBrowse.vue?vue&type=template&id=4aa4854c&scoped=true"
import script from "./AddSingleUserFromBrowse.vue?vue&type=script&lang=js"
export * from "./AddSingleUserFromBrowse.vue?vue&type=script&lang=js"
import style0 from "./AddSingleUserFromBrowse.vue?vue&type=style&index=0&id=4aa4854c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa4854c",
  null
  
)

export default component.exports